import { ENV_API_ENDPOINT, ENV_WS_ENDPOINT } from 'constants/env';

import { getAuthToken } from './graphql/requests';

export const getMessengerAppConfig = () => ({
  host: `${ENV_API_ENDPOINT}/oms/graphql`,
  wsHost: ENV_WS_ENDPOINT,
  accessToken: getAuthToken(),
});
